import { useEffect, useCallback } from 'react';
import getConfig from '../config/env';
const useActivationPostMessage = (
  dataFromChild,
  childUrl,
  refComponent,
  handler
) => {
const allowedOrigin = getConfig()['activation_url'];
  const dataFromActivation = useCallback(
    e => {
      e.preventDefault();
      const data = e.data;
      if (JSON.stringify(dataFromChild) !== JSON.stringify(data)) {
        handler(data);
      }
    },
    [ dataFromChild, handler ]
  );

  useEffect(
    () => {
      window.addEventListener('message', e => {
      const url = new URL(allowedOrigin)
      if(url && url.origin !== e.origin && window.location.origin !== e.origin){
        return;
      }
        // scroll to top when child needs
        if (e.data['task'] === 'scroll_top' && window.scrollY){
           window.scrollTo(0,0);
        }
        if (
          typeof e.data === 'object' &&
          e.data !== null &&
          e.data.name &&
          e.data.url
        ) {
          window.parent.open(e.data.url, e.data.name);
          return;
        }
        // allow user to append siteID to URL so that on refresh user lands to created siteID instead of create new page
        if (!isNaN(e.data) && isNaN(window.location.pathname[[window.location.pathname.length-2]])){
                const location = window.location;
                const pathName = location.pathname;
                const allPathName = pathName.split("/")
                const isSiteIdPresentInUrl = isNaN(allPathName[allPathName.length-1]) || isNaN(allPathName[allPathName.length-2]);
                // only append if siteID not present in URL
                if(isSiteIdPresentInUrl)
                {
                  // activation URL may or may not have '/' at the end
                  const newPathName = pathName[pathName.length-1] === '/' ? pathName : pathName+'/';
                  const newUrl = location.origin +  newPathName + String(e.data) + location.search ;
                  window.history.replaceState(null, null, newUrl);
                }

            }
        dataFromActivation(e);
      });
      return () => {
        window.removeEventListener('message', e => dataFromActivation(e));
      };
    },
    [ dataFromActivation ]
  );

  useEffect(
    () => {
      if (refComponent && refComponent.current && refComponent.current.contentWindow && childUrl) {
        refComponent.current.contentWindow.postMessage(dataFromChild, childUrl);
	if (window.location.origin + "/app/activation_ui" !== childUrl) {
	  refComponent.current.contentWindow.postMessage(dataFromChild, window.location.origin + "/app/activation_ui");
	}
      }
    },
    [ childUrl, dataFromChild, refComponent ]
  );
};

export default useActivationPostMessage;